<template>
  <div>
    <div class="graph-title">
      <el-table
        :data="filteredNodes(ClassifyEventTimeData)"
        align="center"
        stripe
        :header-cell-style="{
          'text-align': 'center',
          background: 'var(--brand)',
          color: '#fff',
        }"
      >
        <el-table-column prop="id" label="事件时间" width="160" align="center">
        </el-table-column>
        <el-table-column prop="description" label="事件描述">
          <template slot-scope="scope">
            <div class="event-desc" @click="openDetail(scope.row.articleId)">
              {{ scope.row.description }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="participant" label="参与者"> </el-table-column> -->
      </el-table>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      title=""
      width="45%"
      @close="handleClose"
      :append-to-body="true"
      :lock-scroll="false"
      top="6vh"
    >
      <article-detail :articleDetail="articleDetail"></article-detail>
    </el-dialog>
  </div>
</template>

<script>
import ArticleDetail from "@/pages/views/project/components/ArticleDetail.vue";
import { GetJfrbArticle } from "@/api/index.js";

export default {
  props: {
    ClassifyEventTimeData: {
      type: Array,
    },
    communityData: {
      type: Array,
    },
  },
  components: {
    ArticleDetail,
  },
  data() {
    return {
      dialogVisible: false,
      articleDetail: {},
    };
  },
  activated() {},
  watch: {},
  computed: {
    sortList() {
      // 提取日期解析逻辑到一个单独的函数中
      // const parseDate = (dateStr) => {
      //   const [year, month, day] = dateStr
      //     .replace(/年|月/g, "-")
      //     .replace(/日/g, "")
      //     .split("-")
      //     .map(Number);
      //   return { year, month, day };
      // };

      // 使用解析后的日期进行排序
      return this.ClassifyEventTimeData.sort((a, b) => {
        return b.date.localeCompare(a.date); //dayB - dayA; // 降序排序日期
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    filteredNodes(nodes) {
      return nodes
        .filter((node) => node.type === "EVENT TIME")
        .map((node) => {
          const matched =
            this.communityData && this.communityData[node.sourceIndex];
          const articleId =
            matched && matched.eventIds && matched.eventIds[0].id;
          return { ...node, articleId: articleId || "" };
        });
    },
    openDetail(id) {
      if (!id) {
        return;
      }
      this.dialogVisible = true;

      GetJfrbArticle({ id: id })
        .then((res) => {
          if (res.succeed) {
            this.articleDetail = res.data;
          }
        })
        .catch((err) => {});
    },

    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.graph-title {
  margin-bottom: 60px;
  h4 {
    color: var(--text-1);
    margin-bottom: 15px;
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    font-weight: bold;
    &::before {
      content: "";
      width: 3px;
      height: 16px;
      background-color: var(--text-2);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
}

.event-desc {
  color: var(--text-1);
  cursor: pointer;
  &:hover {
    color: var(--text-link);
  }
}
</style>
